var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow-box",class:_vm.opacity,on:{"click":_vm.handleClickShadowBox}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }